/**
 * Hello World example component
 */
//const FingerPrint2 = require('fingerprintjs2');
var serialize = require('form-serialize');

module.exports = function (app) {
  app.registerComponent('vote_form', '.js-vote-form', function (sb, el) {

    var formEl = el.querySelector('.gform_wrapper > form');
    var submitEl = el.querySelector('.gform_button');

    var onClick = function (ev) {
      // var url = el.getAttribute('href')

      // // when no fingerprint, try to get the fingerprint
      // // [implement]
      // // if (!app.session.fingerPrint) {

      // // }
      // //sb.publish('header-body/load', url)
      // //console.log( app.session.fingerPrint)

      // sb.publish('overlay/show', {'contentUrl':url})


      // ev.preventDefault()
      // ev.stopPropagation()
    }

    var handleSubmitResponse = function(ev) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = ev.target.response;
      el.innerHTML = tempDiv.querySelector('.js-vote-form').innerHTML;
      //sb.publish('overlay/update_height')
      // reset the component to allow resubmission of the form
      app.resetComponent('vote_form');

      setTimeout(() => { sb.publish('overlay/hide_loader'); }, 0);


    }

    var handleFormSubmit = function() {

      var formAction = formEl.getAttribute('action');
      var xhr = new XMLHttpRequest();
      var formData = serialize(formEl);

      xhr.open('POST',formAction, true);
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onload=handleSubmitResponse; 
      xhr.send(formData);


    }

    var onFormSubmit = function(ev) {
      sb.publish('overlay/show_loader');
      sb.publish('overlay/scrolltop');
      ev.preventDefault();
      ev.stopPropagation();

      setTimeout( handleFormSubmit, 200);
      return false;
    }

    /* INIT ------------------------------------------- */
    return {
      init: function () {
        if (submitEl) submitEl.addEventListener('click', onFormSubmit);
        sb.initializeComponents(el)

      //el.addEventListener('click', onClick)
      },
      destroy: function () {
      }
    }
  })
}



// WEBPACK FOOTER //
// ./assets/js/components/vote-form.js